// @flow

import React from 'react';
import { connect } from 'react-redux';
import Wrapper from './atoms/wrapper.styled';
import Content from './atoms/content.styled';
import { joinArrayOrGetValue } from '../../helpers';
import CollapsibleContent from './atoms/collapsibleContent';
import { getCollapsibleButton } from '../../store/componentSettings/selectors/wysiwygSettings';
import type { ACFThemingOption } from '../../types/acf/themingOption';

type StateProps = {|
  collapsibleButton: ?{
    collapsed: string,
    expanded: string,
  },
|};

type OwnProps = {|
  className?: string,
  readMoreParts?: string,
|};

export type ACFProps = {|
  content: string,
  template: ACFThemingOption,
  position?: ?ACFThemingOption,
  variant?: ?ACFThemingOption,
  replace_macros?: boolean, // eslint-disable-line react/no-unused-prop-types
|};

type StatelessProps = {|
  ...ACFProps,
  ...OwnProps,
|};

export type Props = {|
  ...StatelessProps,
  ...StateProps,
|};

const Wysiwyg = ({
  className,
  content = '<p>&nbsp;</p>',
  readMoreParts = '',
  template,
  position,
  variant,
  collapsibleButton,
}: Props) => (
  <Wrapper
    className={className}
    template={template && joinArrayOrGetValue(template)}
    position={position && joinArrayOrGetValue(position)}
    theme_variant={variant && joinArrayOrGetValue(variant)}
  >
    {collapsibleButton ? (
      <>
        <Content className="content" dangerouslySetInnerHTML={{ __html: content }} />
        {readMoreParts && (
          <CollapsibleContent
            content={readMoreParts}
            buttonTexts={collapsibleButton}
          />
        )}
      </>
    ) : (
      <Content className="content" dangerouslySetInnerHTML={{ __html: content + readMoreParts }} />
    )}
  </Wrapper>
);

Wysiwyg.defaultProps = {
  variant: null,
  position: null,
  readMoreParts: '',
  replace_macros: false,
  className: '',
};

const mapStateToProps = (state): StateProps => ({
  collapsibleButton: getCollapsibleButton(state),
});

export default connect<Props, StatelessProps, any, any, any, any>(mapStateToProps)(Wysiwyg);
